import { Component } from '@angular/core';

@Component({
  selector: 'app-odds-disclaimer',
  standalone: true,
  imports: [],
  templateUrl: './odds-disclaimer.component.html',
  styleUrl: './odds-disclaimer.component.scss'
})
export class OddsDisclaimerComponent {

}
